module.exports = __webpack_public_path__ + "static/media/childrens_museum_mural_rendering_classic_cartoon_style.5c32da92.webp";